/**
 * Devices resource - /api/auth/devices endpoints
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.DevicesResource');
export class DevicesResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * List devices for the current user's organization
     * @param options.trashed - If true, returns only trashed devices; if false/undefined, returns only active devices
     */
    async list(options) {
        log.debug('Listing devices', { trashed: options?.trashed });
        const queryParams = options?.trashed ? '?trashed=true' : '';
        const response = await this.http.get(`/api/auth/devices${queryParams}`);
        log.debug('Devices listed', { count: response.devices.length, trashed: options?.trashed });
        return response;
    }
    /**
     * Register a new device
     */
    async register(name, type = 'cli') {
        log.debug('Registering device', { name, type });
        const response = await this.http.post('/api/auth/devices', { name, type });
        log.info('Device registered', { deviceId: response.device.id, name });
        return response;
    }
    /**
     * Soft delete a device (move to trash)
     */
    async delete(deviceId) {
        log.debug('Soft deleting device', { deviceId });
        await this.http.delete(`/api/auth/devices/${deviceId}`);
        log.info('Device soft deleted', { deviceId });
    }
    /**
     * Restore a deleted device
     */
    async restore(deviceId) {
        log.debug('Restoring device', { deviceId });
        await this.http.post(`/api/auth/devices/${deviceId}/restore`, {});
        log.info('Device restored', { deviceId });
    }
    /**
     * Permanently delete a device
     */
    async permanentDelete(deviceId) {
        log.debug('Permanently deleting device', { deviceId });
        await this.http.delete(`/api/auth/devices/${deviceId}/permanent`);
        log.info('Device permanently deleted', { deviceId });
    }
    /**
     * Get CLIs for a device
     */
    async getClis(deviceId) {
        log.debug('Getting device CLIs', { deviceId });
        const response = await this.http.get(`/api/devices/${deviceId}/clis`);
        log.debug('Device CLIs fetched', { deviceId, count: response.total });
        return response;
    }
}
//# sourceMappingURL=DevicesResource.js.map